export default {
  header: 'Tagi zdarzeń',
  empty: 'Nie utworzono jeszcze żadnych tagów zdarzeń.',
  confirmDelete: 'Czy na pewno chcesz usunąć "{item}"? Zdarzenia, które już mają ten tag, zachowają go.',
};
